import { ReactNode } from "react";

interface PanelProps {
  title: string;
  subtitle?: string;
  claimCeiling: string;
  children: ReactNode;
}

/**
 * Bloomberg-style terminal panel. Every panel surfaces the claim ceiling so
 * UI cannot show "proven" without an evidence path.
 */
export function Panel({ title, subtitle, claimCeiling, children }: PanelProps) {
  return (
    <section className="aev-panel" data-claim-ceiling={claimCeiling}>
      <header className="aev-panel__header">
        <h2 className="aev-panel__title">{title}</h2>
        {subtitle ? <p className="aev-panel__subtitle">{subtitle}</p> : null}
        <span className="aev-panel__ceiling" aria-label="claim ceiling">
          {claimCeiling}
        </span>
      </header>
      <div className="aev-panel__body">{children}</div>
    </section>
  );
}
